import { InvoicePaymentStatus } from "@api/graphql/generated/generated-types";

export function formatInvoicePaymentStatus(
  status: InvoicePaymentStatus
): string {
  switch (status) {
    case InvoicePaymentStatus.Unpaid:
      return "Unpaid";
    case InvoicePaymentStatus.PaymentProcessing:
      return "Payment Processing";
    case InvoicePaymentStatus.PartialPaid:
      return "Partial Paid";
    case InvoicePaymentStatus.Paid:
      return "Paid";
  }
}
